import "../App.css";

export default function UserProfile() {
  const handleLogout = () => {
    localStorage.removeItem("userId");
    sessionStorage.removeItem("userId");
    window.location.href = "/login";
  };

  return (
    <div>
      <h2>Profiel</h2>
      <button onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}